import TubCommon from "./tubCommon";

export default class ReplacementTub extends TubCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = 'replacement_tub';
    this.bottomTubId = "replacement_tub";
    this.visible = true;
    this.partName = 'Replacement Tub';
    this.translateId = "visualizer.bathroom.shower_tub_combo.replacement_tub";
    this.isStoneFeature = false;
    this.disableOnHomeSections = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new ReplacementTub());
  }

  setZIndex(zIndexes) {
    const zIndex = zIndexes.Shower.TubCombo.ReplacementTub;
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndex;
    }
    if (zIndexes && this.placeholderFeature) {
      this.placeholderFeature.layer.zIndex = zIndex;
    }
  }
}
